import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from './Redirector.module.css';

const Redirector = () => {
  const { codigo } = useParams();
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`https://multitenant-service.onboarding.smilego.io/api/valkyria/shortenings/${codigo}/code`);
        if (response.ok) {
          const data = await response.json();
          window.location.href = data.url;  // Realiza o redirecionamento externo
        } else {
          throw new Error('Url inválida');
        }
      } catch (error) {
        setLoading(false);
        setErrorMessage(error.message);
      }
    };

    fetchData();
  }, [codigo]);

  if (loading) {
    return <p>Carregando...</p>;
  }

  if (errorMessage) {
    return <div className={styles.errorMessage}>{errorMessage}</div>;  // Exibe a mensagem de erro na tela
  }

  return null;  // Nada é renderizado se não está carregando e não há erro
};

export default Redirector;
